import { createContext, useContext } from "react";

import { MarketingCampaignFormModelContext } from "../../_shared/context";

import type { MarketingCampaignFormModelContextType } from "../../_shared/context/context";

export type MarketingNewCampaignFormModelContextType = {
	onSave: () => void;
	onPublish: () => void;
} & MarketingCampaignFormModelContextType;

export const MarketingNewCampaignFormModelContext = createContext<MarketingNewCampaignFormModelContextType | null>(
	null,
);

export const MarketingNewCampaignFormModelContextProvider = ({
	value,
	children,
}: {
	value: MarketingNewCampaignFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<MarketingNewCampaignFormModelContext.Provider value={value}>
			<MarketingCampaignFormModelContext.Provider value={value}>
				{children}
			</MarketingCampaignFormModelContext.Provider>
		</MarketingNewCampaignFormModelContext.Provider>
	);
};

export const useMarketingNewCampaignFormModelContext = () => {
	const context = useContext(MarketingNewCampaignFormModelContext);

	if (!context) {
		throw new Error(
			"useMarketingNewCampaignFormModelContext must be used within a MarketingNewCampaignFormModelContextProvider",
		);
	}

	return {
		onSave: context.onSave,
		onPublish: context.onPublish,
	};
};
